import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  CoachmarkCanvas,
  HighlightFrame,
  SkeletonBar,
  SkeletonBlock,
} from '../../../../components/field-coachmark/CoachmarkSkeleton';
import type { CoachmarkState } from '../../../../components/field-coachmark/FieldCoachmark';

const SAMPLE_CID = 'J06.9';

const Panel = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={theme => ({
      flex: 1,
      minWidth: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: 0.75,
      padding: 0.75,
      borderRadius: '6px',
      border: `1px solid ${theme.palette.divider}`,
    })}
  >
    {children}
  </Box>
);

const CidChip = ({ value }: { value: string }) => (
  <Typography sx={{ fontSize: 10.5, fontWeight: 600, color: 'text.primary', whiteSpace: 'nowrap' }}>
    {`CID ${value}`}
  </Typography>
);

const CidPanel = ({ masked }: { masked?: boolean }) => (
  <Panel>
    <SkeletonBar width={40} height={5} />
    <Box>
      <HighlightFrame>
        <CidChip value={masked ? '***' : SAMPLE_CID} />
      </HighlightFrame>
    </Box>
    {masked ? (
      <Typography sx={{ fontSize: 10, fontWeight: 600, color: 'text.primary', letterSpacing: 1 }}>***</Typography>
    ) : (
      <SkeletonBar width="80%" height={5} />
    )}
  </Panel>
);

const AttachmentsPanel = ({ masked }: { masked?: boolean }) => (
  <Panel>
    <SkeletonBar width={34} height={5} />
    <HighlightFrame sx={{ padding: '4px 6px', alignSelf: 'flex-start' }}>
      <Box sx={{ display: 'flex', gap: 0.75, opacity: masked ? 0.5 : 1 }}>
        <SkeletonBlock width={30} height={26} blur={masked ? 3 : undefined} />
        <SkeletonBlock width={30} height={26} blur={masked ? 3 : undefined} />
      </Box>
    </HighlightFrame>
  </Panel>
);

const Screen = ({ masked }: { masked?: boolean }) => (
  <CoachmarkCanvas>
    <SkeletonBar width={78} height={7} />
    <Box sx={{ display: 'flex', alignItems: 'stretch', gap: 0.75 }}>
      <CidPanel masked={masked} />
      <AttachmentsPanel masked={masked} />
    </Box>
  </CoachmarkCanvas>
);

export const showCidForManagerStates: CoachmarkState[] = [
  { label: 'Marcado', preview: <Screen /> },
  { label: 'Desmarcado', preview: <Screen masked /> },
];
